<template>
  <version-card title="系统更新">
    <div class="system-update-info-content">
      <div class="header">
        <div>TacOS</div>
        <div class="item">
          <p class="blod">当前版本</p>
          <p class="text">{{ detail.currentVersion }}</p>
        </div>
        <div class="item">
          <p class="blod">更新时间</p>
          <p>{{ detail.updateTime }}</p>
        </div>
      </div>
      <div class="content">
        <h5 class="h5">检测到更新</h5>
        <div class="update-block">
          <div class="top">
            <div class="version">{{ detail.updateVersion }}</div>
            <a-button class="btn button-border-primary">立即更新</a-button>
          </div>
          <div class="total">本次更新项（{{ detail.total }}）</div>
          <div class="items">
            <p v-for="item in detail.items" :key="item">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
  </version-card>
</template>

<script>
import Card from "@/components/dashboard/devops/version/card.vue";
import { Button } from "ant-design-vue";
export default {
  name: "system-update-info",
  components: {
    [Card.name]: Card,
    [Button.name]: Button
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.system-update-info-content {
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  .header {
    display: flex;
    justify-content: space-between;
    height: 80px;
    padding: 16px;
    border-bottom: 1px solid #e5e6eb;
    & > div {
      flex: 1;
    }
    & > :first-child {
      margin-top: 8px;
      margin-right: 16px;
      color: #1d2129;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
    }
    .item {
      margin-right: 16px;
      color: #86909c;
      line-height: 22px;
      .blod {
        margin-bottom: 4px;
        color: #1d2129;
      }
    }
    :last-child {
      margin-right: 0;
    }
  }
  .content {
    padding: 24px;
    .h5 {
      margin-bottom: 14px;
      color: #1d2129;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
    }
    .update-block {
      padding: 24px;
      // height: 286px;
      color: #4e5969;
      background: #f7f8fa;
      .top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        .version {
          color: #1d2129;
          font-weight: 500;
          font-size: 16px;
          line-height: 32px;
        }
        .btn {
          padding: 4px 18px;
        }
      }
      .total {
        margin-bottom: 12px;
        color: #1d2129;
        line-height: 22px;
      }
      .items {
        :not(:last-child) {
          margin-bottom: 12px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
